<template>
  <form-field-input
      v-bind="$attrs"
      :label="label"
      v-model="input"
      @blur="handleInput"
      :validation-errors="validationErrors"
      placeholder="Enter time e.g. 3h 20m"
  ></form-field-input>
</template>

<script>
export default {
  name: "FormFieldTimeInMinutes",
  props: {
    value: {
      type: [String, Number, Boolean, Date]
    },
    label: {
      type: String,
      required: true,
    },
    validationErrors: {
      type: Array,
      default: () => []
    },
  },
  data() {
    return {
      input: null,
      timeSpans: [
        {
          tags: ['year', 'y', 'yr'],
          value: 365 * (24 * 60),
        },
        {
          tags: ['month'],
          value: 30 * (24 * 60),
        },
        {
          tags: ['week', 'w', 'wk'],
          value: 7 * (24 * 60),
        },
        {
          tags: ['day', 'd'],
          value: (24 * 60),
        },
        {
          tags: ['hour', 'h', 'hr'],
          value: 60,
        },
        {
          tags: ['minute', 'm', ''],// the '' allows for it to default to minutes for values that dont have a value tag applied
          value: 1,
        },
      ]
    }
  },
  mounted() {
    this.input = this.convertMinutesToUserInput(this.value);
  },
  watch: {
    value(value) {
      this.input = this.convertMinutesToUserInput(value);
    }
  },
  methods: {
    convertMinutesToUserInput(minutes) {
      let input = '';
      this.timeSpans.forEach((timespan) => {
        let times = Math.floor(minutes / timespan.value);
        minutes = minutes % timespan.value;
        if (times > 0) {
          input += ' ' + times + ' ' + timespan.tags[0];
        }
        if (times > 1) {
          input += 's';
        }
      });

      return input;
    },
    convertUserInputToMinutes(input) {
      let minutes = 0;
      input = input.replace(/s/g, '');

      const regexp = /(\d+)\s*([^\d\s]*)/g;
      [...input.matchAll(regexp)].forEach((match) => {
        let value = match[1];
        let tag = match[2];

        let timespan = this.timeSpans.find((span) => span.tags.includes(tag));
        if (timespan) {
          minutes += timespan.value * value;
        }
      });

      return minutes;
    },
    handleInput() {
      let minutes = this.convertUserInputToMinutes(this.input);

      this.input = this.convertMinutesToUserInput(minutes);

      this.$emit('input', minutes);
      this.$emit('change', minutes);
      this.$emit('selected', minutes);
    }
  }
}
</script>

<style scoped>

</style>
